<template>
  <div class="aa-faq-app container-fluid">
    <ul class="nav nav-tabs aa-faq-app__nav">
      <li class="nav-item">
        <router-link to="/" class="nav-link">All</router-link>
      </li>
      <li class="nav-item">
        <router-link to="/leads" class="nav-link">Syndicate Leads</router-link>
      </li>
      <li class="nav-item">
        <router-link to="/lp" class="nav-link">Angel Investors</router-link>
      </li>
      <li class="nav-item">
        <router-link to="/founder" class="nav-link">Founders</router-link>
      </li>
    </ul>
    <router-view/>
  </div>
</template>
<script setup lang="ts">
</script>
